// 原生js的ajax模块化+promise
// import request from './request'

// 使用qs库对post提交的数据进行格式化
// import qs from 'qs';

export default {
    // 根据ticket单点登录  window.apis.loginByTicket
    getTotalChatCount(params = {}) {
        if(!process.env.REACT_APP_BASE_URL){
            return 'http://localhost:8099/api/portal/getTotalChatCount'
        }
        else{
            return `${process.env.REACT_APP_BASE_URL}/api/portal/getTotalChatCount`
        }
    }

}
